import type {
  AssignedWorkflow,
  WorkflowAction,
} from '../../shared/hooks/useIncidentWorkflow'
import {
  formatActionTimestamp,
  useWorkflowActionUserNames,
} from '../../shared/hooks/useWorkflowActionUserNames'
import { useLightMode } from '@/hooks/useLightMode'

import { SteppedList, SteppedListSection, SuccessBanner } from '@hivewatch/dark'

interface WorkflowCompleteStateIProps {
  assignedWorkflow: AssignedWorkflow | null
  workflowActions: WorkflowAction[]
}

export const WorkflowCompleteState = ({
  assignedWorkflow,
  workflowActions,
}: WorkflowCompleteStateIProps) => {
  const mode = useLightMode()
  const stepMap = new Map(
    assignedWorkflow?.steps.map((s) => [s.id, s.prompt]) ?? []
  )
  const userNameMap = useWorkflowActionUserNames(workflowActions)

  return (
    <SteppedList colorScheme={mode}>
      {workflowActions.map((action) => (
        <SteppedListSection
          colorScheme={mode}
          content={action.outcomeValue}
          header={stepMap.get(action.sourceNodeId) ?? action.sourceNodeId}
          key={action.id}
          metadata={{
            completedAt: formatActionTimestamp(action.actionTimestamp),
            name: userNameMap.get(action.userId) ?? '',
          }}
        />
      ))}
      <SuccessBanner colorScheme={mode} label='Workflow complete' mb='12px' />
    </SteppedList>
  )
}
